import anime from 'animejs/lib/anime.es.js'

var $accordions = $('.js-Accordion');

$accordions.each(function(_, it) {
    var $root = $(it);
    var $pieces = $root.find('.js-Accordion-piece');


    $root.on('click', '.js-Accordion-piece-title', function(event) {
        var $piece = $(event.target).closest('.js-Accordion-piece');
        var $drawer = $piece.find('.js-Accordion-piece-drawer');

        if ($piece.attr('data-open') == "false") {
            $piece.attr('data-open', true);

            $drawer.css({'display': 'block'});
            var height = $drawer.height();
            $drawer.css({'height': '0'});

            anime({
                targets: $drawer[0],
                'height': [0, height],
                easing: "cubicBezier(0.335, 0, 0.335, 1)",
                duration: 200,
                complete: function() {
                    $drawer.removeAttr('style');
                }
            });
        } else {
            $piece.attr('data-open', false);

            var height = $drawer.height();

            anime({
                targets: $drawer[0],
                'height': [height, 0],
                easing: "cubicBezier(0.335, 0, 0.335, 1)",
                duration: 200,
                complete: function() {
                    $drawer.removeAttr('style');
                    $drawer.css({'display': 'none'});
                }
            });
        }
    });

    $pieces.each(function(_, piece) {
        var $piece = $(piece);
        var $drawer = $piece.find('.js-Accordion-piece-drawer');

        if ($piece.attr('data-open') == "false") {
            $drawer.css({'display': 'none'});
        }
    });
});